import useCanPurchaseSubscriptionBox from '@context/subscription-box/useCanPurchaseSubscriptionBox'
import useSWR from 'swr'

import type { AddToCartProps } from '@components/product/ProductView/AddToCart'

import getCanAddToCart from './get-can-add-to-cart'

export type UseCanAddToCartParams = Pick<AddToCartProps, 'product' | 'variant'>

export default function useCanAddToCart({ product, variant }: UseCanAddToCartParams) {
	const { canAddSubscriptionBoxToCart, subscriptionBoxInCart, alreadyPurchasedSubscriptionBox } =
		useCanPurchaseSubscriptionBox()

	const { data: canAddToCart } = useSWR(
		[
			alreadyPurchasedSubscriptionBox,
			product,
			variant,
			canAddSubscriptionBoxToCart,
			subscriptionBoxInCart
		],
		() =>
			getCanAddToCart({
				alreadyPurchasedSubscriptionBox,
				product,
				variant,
				canAddSubscriptionBoxToCart,
				subscriptionBoxInCart
			})
	)

	return canAddToCart
}
